import './App.scss';
import {MainRoute} from '@src/routes';
import { PlayerRoute } from '@src/routes/SubRoutes/Player';
import {Footer} from './components';

const logger=Logger.get('app');
function App() {
  logger.log('app loaded');
  return (
    <div className="app">
      {/** main route page */}
        <div className="app-page">
          <div className="main-route">
            <MainRoute />
          </div>
          <Footer></Footer>
        </div>
      {/** main route page */}
      {
        /** player route view */
          <PlayerRoute />
        /** player route view */
      }

    </div>
  );
}


export default App;
